import React from 'react';
import AdminSearchInput from './AdminSearchInput';
import SearchTypeSelect from './SearchTypeSelect';

const AdminSearchBar = ({
  value,
  onChange,
  placeholder = 'Rechercher...',
  highlightContent = null,
  imgBack = null,
  optionValue = '',
  onOptionChange,
  searchOptions = [],
  showTypeSelect = false,
  inputWrapperClassName = 'flex-1',
  selectWrapperClassName = 'w-[140px]',
  selectClassName = '',
}) => {
  return (
    <div className="flex gap-2 items-center w-full">
      <div className={inputWrapperClassName}>
        <AdminSearchInput
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          highlightContent={highlightContent}
          imgBack={imgBack}
        />
      </div>
      {showTypeSelect && (
        <div className={selectWrapperClassName}>
          <SearchTypeSelect
            value={optionValue}
            onChange={onOptionChange}
            options={searchOptions}
            className={selectClassName}
          />
        </div>
      )}
    </div>
  );
};

export default AdminSearchBar;
